import { render, staticRenderFns } from "./topicAnswer.vue?vue&type=template&id=2f2f0119&scoped=true&"
import script from "./topicAnswer.vue?vue&type=script&lang=js&"
export * from "./topicAnswer.vue?vue&type=script&lang=js&"
import style0 from "./topicAnswer.vue?vue&type=style&index=0&id=2f2f0119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f0119",
  null
  
)

export default component.exports